import { FlexColumn, FlexRow, LabeledInput, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useEffect, useState } from 'react';
import { ScalingMatrix } from '../../types/subClient';
import { REQUIRED_FIELD_TEXT } from '../../constants/app';
import { LabeledInternationalPhoneInput } from '../ui/LabeledInternationalPhoneInput';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  scalingMatrixItem?: ScalingMatrix;
  onChange: (scalingMatrixItem: ScalingMatrix) => void;
  isValid?: (valid: boolean) => void;
  onRemove?: () => void;
};
export function ScalingMatrixForm({ scalingMatrixItem, onChange, isValid, onRemove }: Readonly<Props>) {
  const { css } = useStyles();
  const [isValidPhone, setIsValidPhone] = useState(false);
  const [touchedName, setTouchedName] = useState(false);
  const [touchedMinutes, setTouchedMinutes] = useState(false);

  const validateControlTowerScalingMatrix = (value: ScalingMatrix): boolean => {
    if (!value?.phone || !isValidPhone) return false;
    if (!value?.name) return false;
    if (!value?.minutes || value?.minutes > 60) return false;
    return true;
  };

  useEffect(() => {
    if (scalingMatrixItem && isValid) {
      isValid(validateControlTowerScalingMatrix(scalingMatrixItem));
    }
  }, [scalingMatrixItem, isValidPhone]);

  const onInputChange = (value: string | number | undefined | null, field: keyof ScalingMatrix) => {
    onChange({
      ...scalingMatrixItem!,
      [field]: value,
    });
  };

  return (
    <FlexColumn>
      <FlexRow>
        <LabeledInput
          label="Nombre:"
          value={scalingMatrixItem?.name}
          onChange={(value) => onInputChange(value, 'name')}
          error={touchedName ? scalingMatrixItem?.name ? undefined : REQUIRED_FIELD_TEXT : undefined}
          onBlur={() => setTouchedName(true)}
          required
        />
        {onRemove && (
          <span>
            <StyledButton size='mini' kind='tertiary' shape='square' onClick={onRemove}>
              <MaterialIcon name='remove'/>
            </StyledButton>
          </span>
        )}
      </FlexRow>
      <FlexRow>
        <LabeledInternationalPhoneInput
          value={scalingMatrixItem?.phone}
          onChange={(phone) => onInputChange(phone, 'phone')}
          type="simple"
          isPhoneValid={setIsValidPhone}
          required
        />
        <FlexRow classNames={css({flex: '50%', minWidth: '150px'})}>
          <LabeledInput 
            label="Minutos:"
            value={scalingMatrixItem?.minutes}
            onChange={(minutes) => {
              if (minutes) {
                onInputChange(+minutes, 'minutes')
              } else {
                onInputChange(undefined, 'minutes')
              }
            }}
            type='number'
            error={touchedMinutes ? 
              scalingMatrixItem?.minutes 
                ? scalingMatrixItem?.minutes > 60
                  ? `El tiempo no puede ser mayor a 60min.`
                  : undefined
                : REQUIRED_FIELD_TEXT
              : undefined
            }
            onBlur={() => setTouchedMinutes(true)}
            required
            min={0}
            max={60}
          />
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  );
}
